import { Lock } from "lucide-react";
import { Seo } from "@/components/site/Seo";

export const AuthShell = ({ title, intro, children, testId }) => (
  <section className="grain relative flex min-h-[90svh] items-start bg-navy pb-20 pt-36 text-paper" data-testid={testId}>
    <Seo title="Staff Access | First Responders Foundation" description="Staff-only page." path="/staff" noindex />
    <div className="container-x">
      <div className="max-w-xl">
      <Lock className="text-gold" size={30} aria-hidden="true" />
      <h1 className="mt-6 text-3xl font-extrabold text-paper md:text-4xl">{title}</h1>
      {intro && <p className="mt-3 text-sm leading-relaxed text-[#C9D4DF]">{intro}</p>}
      <div className="mt-10 bg-paper p-6 text-ink md:p-8">{children}</div>
      </div>
    </div>
  </section>
);

export const Field = ({ label, hint, ...props }) => (
  <label className="block">
    <span className="mb-2 block text-sm font-semibold text-navy">{label}</span>
    <input className="field-input" {...props} />
    {hint && <span className="mt-1 block text-xs text-slate">{hint}</span>}
  </label>
);

export const Status = ({ status, testId }) =>
  status?.msg ? (
    <p role={status.state === "error" ? "alert" : "status"}
      className={`text-sm ${status.state === "error" ? "text-fire" : "text-navy"}`} data-testid={testId}>
      {status.msg}
    </p>
  ) : null;
